module.exports = __webpack_public_path__ + "img/img_bishexuanti.a017670c.svg";